var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXswap = function SvgXswap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.492,
    y: 0.117,
    width: 16.176,
    height: 5.646,
    rx: 2.823,
    transform: "rotate(45.221 4.492 .117)",
    fill: "#07A658"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.652,
    y: 3.117,
    width: 12.204,
    height: 1.647,
    rx: 0.824,
    transform: "rotate(45.221 4.652 3.117)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05 12.676 6.896 13.86a2.832 2.832 0 0 1-4 .042 2.832 2.832 0 0 1-.056-4L3.995 8.72l4.056 3.957Z",
    fill: "#07A658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.275 12.438a.83.83 0 0 1-.009-1.174l1.148-1.166 1.184 1.165L5.45 12.43a.83.83 0 0 1-1.175.01Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.11 7.545 1.174-1.166a2.81 2.81 0 1 0-3.96-3.989L9.148 3.556l3.96 3.989Z",
    fill: "#07A658"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.917 3.816a.83.83 0 0 0-1.174-.004l-1.18 1.17 1.171 1.179 1.179-1.17a.83.83 0 0 0 .004-1.175Z",
    fill: "#fff"
  })));
};
export default SvgXswap;